import { accountThumbnailsStyles } from "@ces/App/Widgets/AccountThumbnails/AccountThumbnails";
import LinkArrowRight from "@ces/XDL/Icons/LinkArrowRight";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, createLinkIconStyles, layoutContainer, xScreen } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

accountThumbnailsStyles.spinnerWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
    `,
};
accountThumbnailsStyles.widgetWrapper = {
    css: css`
        ${({ background }: any) => (background ? `background-image: url('${background}');` : "")}
        ${({ fullHeight }: any) => (!fullHeight ? "background-size: 100% 113px;" : "background-size: 100% 100%;")};
        background-repeat: no-repeat;
        ${xScreen("lt", "sm")} {
            ${({ fullHeight }: any) => (!fullHeight ? "background-size: 100% 146px;" : "")};
        }
    `,
};
accountThumbnailsStyles.wrapper = {
    css: css`
        ${layoutContainer}
        display: flex;
        flex: 1;
        flex-direction: column;
        ${({ responsive }: any) => (responsive ? "gap: 12px; padding-top: 0px;" : "gap: 20px; padding-top: 20px;")}
    `,
};

accountThumbnailsStyles.infoSection = {
    css: css`
        display: flex;
        gap: 8px 32px;
        align-items: baseline;
        flex-wrap: wrap;

        ${TypographyStyle} {
            ${({ color = "#fff" }: any) => `
                color: ${color}
            `}
        }
    `,
};

accountThumbnailsStyles.responsiveSmallHeadingAndText = {
    wrapper: {
        css: css`
            display: flex;
            gap: 4px;
            align-items: center;
            flex-direction: row;
            width: auto;
        `,
    },
    heading: {
        color: "white",
        css: css`
            font-size: 16px;
            font-weight: ${fontConfig.weight.bold};
            letter-spacing: 0;
            line-height: 26px;
            white-space: nowrap;
            text-transform: none;
            margin: 0;
            &::after {
                content: ":";
            }
        `,
    },
    text: {
        color: "white",
        ellipsis: true,
        css: css`
            font-size: 16px;
            font-weight: ${fontConfig.weight.bold};
            letter-spacing: 0;
            line-height: 26px;
            white-space: nowrap;
            margin: 0;
            max-width: 40ch;
        `,
    },
};

accountThumbnailsStyles.smallHeadingAndText = {
    wrapper: {
        css: css`
            display: flex;
            gap: 4px;
            align-items: center;
            flex-direction: row;
            width: auto;
        `,
    },
    heading: {
        variant: "h4",
        color: "white",
        css: css`
            white-space: nowrap;
            margin: 0;
            &::after {
                content: ":";
            }
        `,
    },
    text: {
        variant: "h4",
        color: "white",
        ellipsis: true,
        css: css`
            white-space: nowrap;
            margin: 0;
            max-width: 40ch;
        `,
    },
};

accountThumbnailsStyles.titleSection = {
    css: css`
        display: flex;
        gap: 5px;
    `,
};

accountThumbnailsStyles.greetingTitle = accountThumbnailsStyles.title = {
    css: css`
        ${({ responsive }: any) =>
            responsive ? "font-size: 20px; line-height: 26px;" : "font-size: 28px; line-height: 34px;"}
        font-weight: ${fontConfig.weight.bold};
        letter-spacing: 0;
        margin: 0;
        white-space: nowrap;
    `,
};

accountThumbnailsStyles.thumbnailsContainer = {
    gap: 22,
};

accountThumbnailsStyles.thumbnailItem = {
    width: [12, 12, 6, 3, 3],
    css: css`
        ${xScreen("lt", "lg")} {
            ${({ responsive }: any) => (responsive ? "padding: 12px 11px 0px;" : "")}
        }
        ${xScreen("lt", "sm")} {
            ${({ responsive }: any) => (responsive ? "" : "padding-block: 6px;")}
        }
    `,
};

accountThumbnailsStyles.itemContainer = {
    css: css`
        display: flex;
        flex: 1;
        border: 1px solid ${color("common.border")};
        border-radius: 2px;
        background-color: ${color("white")};
        gap: 12px;
        padding: 10px 12px 12px 0;
        height: 100%;
    `,
};

accountThumbnailsStyles.itemInfoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

accountThumbnailsStyles.item = {
    titleContainer: {
        css: css`
            display: flex;
            column-gap: 8px;
            align-items: baseline;
            min-height: 34px;
            flex-wrap: wrap;
            flex: 1;
        `,
    },
    title: {
        variant: "h5",
        as: "p",
        css: css`
            margin: 0;
            ${({ numberless }: any) => (numberless ? "margin-top: auto;" : "")}
            white-space: nowrap;
        `,
    },
    number: {
        variant: "h2",
        as: "p",
        css: css`
            margin: 0;
            white-space: nowrap;
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            width: 69px;
            margin-top: 7px;
            border-right: 1px solid ${color("common.border")};
            ${IconWrapper}, &&& svg {
                width: auto;
                height: auto;
                max-width: 45px;
                max-height: 40px;
            }
        `,
    },
    image: {
        css: css`
            & > img {
                height: 100%;
                width: 100%;
                max-width: 45px;
                max-height: 40px;
            }
        `,
    },
    link: {
        ...createLinkIconStyles({
            icon: LinkArrowRight,
            iconPosition: "right",
            typographyStyles: {
                size: 12,
                lineHeight: "15px",
                css: css`
                    white-space: nowrap;
                `,
            },
        }),
    },
};
